import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppComponent } from '../../app.component';

@Component({
    imports: [RouterOutlet],
    selector: 'creativeset-component',
    templateUrl: './creativeset.component.html'
})
export class CreativesetComponent implements OnInit {
    private app = inject(AppComponent);

    ngOnInit(): void {
        this.app.finishInit();
    }
}
